import { render } from "./Dreamforce.vue?vue&type=template&id=19d9691e&scoped=true"
import script from "./Dreamforce.vue?vue&type=script&lang=js"
export * from "./Dreamforce.vue?vue&type=script&lang=js"

import "./Dreamforce.vue?vue&type=style&index=0&id=19d9691e&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d9691e"]])

export default __exports__